import { render, staticRenderFns } from "./VSubMenu.vue?vue&type=template&id=0f439697&scoped=true&"
import script from "./VSubMenu.vue?vue&type=script&lang=js&"
export * from "./VSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./VSubMenu.vue?vue&type=style&index=0&id=0f439697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f439697",
  null
  
)

export default component.exports